import React, { useState } from "react";
import { ChevronLeft, ChevronRight, Maximize2, X } from "lucide-react";

export const CabinCarousel = ({ photos, name, testIdPrefix = "carousel" }) => {
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const total = photos.length;

  const prev = () => setIndex((i) => (i - 1 + total) % total);
  const next = () => setIndex((i) => (i + 1) % total);

  return (
    <>
      <div
        className="relative w-full overflow-hidden rounded-2xl bg-[#1a3622]/5 aspect-[4/3] md:aspect-[16/10] card-soft group"
        data-testid={`${testIdPrefix}-root`}
      >
        {photos.map((p, i) => (
          <img
            key={p}
            src={p}
            alt={`${name} - foto ${i + 1}`}
            loading={i === 0 ? "eager" : "lazy"}
            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${
              i === index ? "opacity-100" : "opacity-0"
            }`}
          />
        ))}

        {/* Arrows */}
        <button
          aria-label="Foto anterior"
          data-testid={`${testIdPrefix}-prev`}
          onClick={prev}
          className="absolute left-3 top-1/2 -translate-y-1/2 h-11 w-11 rounded-full bg-white/85 hover:bg-white text-[#1a3622] flex items-center justify-center shadow-md backdrop-blur transition-all hover:scale-105"
        >
          <ChevronLeft className="h-5 w-5" />
        </button>
        <button
          aria-label="Próxima foto"
          data-testid={`${testIdPrefix}-next`}
          onClick={next}
          className="absolute right-3 top-1/2 -translate-y-1/2 h-11 w-11 rounded-full bg-white/85 hover:bg-white text-[#1a3622] flex items-center justify-center shadow-md backdrop-blur transition-all hover:scale-105"
        >
          <ChevronRight className="h-5 w-5" />
        </button>

        {/* Expand */}
        <button
          aria-label="Ampliar foto"
          data-testid={`${testIdPrefix}-expand`}
          onClick={() => setOpen(true)}
          className="absolute top-3 right-3 h-9 w-9 rounded-full bg-black/40 hover:bg-black/55 text-white flex items-center justify-center backdrop-blur-sm"
        >
          <Maximize2 className="h-4 w-4" />
        </button>

        {/* Counter */}
        <div className="absolute bottom-3 right-3 bg-black/55 text-white text-xs px-3 py-1.5 rounded-full backdrop-blur-sm">
          {index + 1} / {total}
        </div>

        {/* Dots */}
        <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5">
          {photos.map((_, i) => (
            <button
              key={i}
              aria-label={`Ir para foto ${i + 1}`}
              onClick={() => setIndex(i)}
              className={`h-1.5 rounded-full transition-all ${
                i === index ? "w-6 bg-white" : "w-1.5 bg-white/55"
              }`}
            />
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {open && (
        <div
          className="fixed inset-0 z-[60] bg-black/90 flex items-center justify-center p-4"
          onClick={() => setOpen(false)}
          data-testid={`${testIdPrefix}-lightbox`}
        >
          <button
            aria-label="Fechar"
            className="absolute top-5 right-5 text-white h-10 w-10 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center"
            onClick={() => setOpen(false)}
          >
            <X className="h-5 w-5" />
          </button>
          <button
            aria-label="Foto anterior"
            onClick={(e) => {
              e.stopPropagation();
              prev();
            }}
            className="absolute left-4 top-1/2 -translate-y-1/2 h-12 w-12 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center"
          >
            <ChevronLeft className="h-6 w-6" />
          </button>
          <img
            src={photos[index]}
            alt={`${name} - foto ${index + 1}`}
            className="max-h-[88vh] max-w-[92vw] object-contain rounded-xl"
            onClick={(e) => e.stopPropagation()}
          />
          <button
            aria-label="Próxima foto"
            onClick={(e) => {
              e.stopPropagation();
              next();
            }}
            className="absolute right-4 top-1/2 -translate-y-1/2 h-12 w-12 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center"
          >
            <ChevronRight className="h-6 w-6" />
          </button>
        </div>
      )}
    </>
  );
};
